<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/status/change/record/page" getKey="rows"
			:columns="columns" @afterGet="handleAfterGet">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')">
            <el-input disabled v-model="woNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shijishengchanshichang(h)')">
            <el-input disabled v-model="durationTotal"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #top2>
        <div style="width:calc(100% + 50px);margin-left: -50px;">
          <div style="width: 100%;" :style="{ height: chartHeight + 'px' }" :id="'web_production_management_work_order_execution_report_list'">
          </div>

        </div>
      </template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
<!--				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
    </yi_curd_table>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_production_management_work_order_execution_wo_status',
		components: {
			// work_bom
		},
		data() {
			return {
        durationTotal: 0,
        woNo: this.$attrs.woInfo.no,
				columns: [
          {
            label: 'gongdanzhuangtai-xiugaiqian',
            type: 'tag',
            prop: 'woStatusBefore',
            width: 180,
            tags: {
              1: {
                color: '#419FFF',
                text: this.$t('xinjian')
              },
              2: {
                color: '#419FFF',
                text: this.$t('fafang')
              },
              3: {
                color: '#67C23A',
                text: this.$t('shengchanzhong')
              },
              4: {
                color: '#F56C6C',
                text: this.$t('zanting')
              },
              5: {
                color: '#67C23A',
                text: this.$t('shougongxuwangong')
              },
              6: {
                color: '#67C23A',
                text: this.$t('wangong')
              },
              7: {
                color: '#909399',
                text: this.$t('guanbi')
              },
              8: {
                color: '#E6A23C',
                text: this.$t('yidiaobo')
              }
            }
          },
          {
            label: 'gongdanzhuangtai-xiugaihou',
            type: 'tag',
            prop: 'woStatusAfter',
            width: 180,
            tags: {
              1: {
                color: '#419FFF',
                text: this.$t('xinjian')
              },
              2: {
                color: '#419FFF',
                text: this.$t('fafang')
              },
              3: {
                color: '#67C23A',
                text: this.$t('shengchanzhong')
              },
              4: {
                color: '#F56C6C',
                text: this.$t('zanting')
              },
              5: {
                color: '#67C23A',
                text: this.$t('shougongxuwangong')
              },
              6: {
                color: '#67C23A',
                text: this.$t('wangong')
              },
              7: {
                color: '#909399',
                text: this.$t('guanbi')
              },
              8: {
                color: '#E6A23C',
                text: this.$t('yidiaobo')
              }
            }
          },
          {
            label: 'caozuoshijian',
            prop: 'createTime',
            type: 'time',
            width: 200
          },
          {
            label: 'caozuoren',
            prop: 'createByObject.nickname',
            width: 200
          }
				]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.conditions = {
					woId: this.$attrs.woInfo.id,
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
			handleAfterGet() {
				// 重置durationTotal
				this.durationTotal = 0;
				// 遍历表格数据，累加duration字段
				if (this.yt.list && this.yt.list.length > 0) {
					this.yt.list.forEach(item => {
						// 只有当woStatusBefore为3（生产中）时才累加duration
						if (item.woStatusBefore === '3' && item.duration && !isNaN(parseFloat(item.duration))) {
							// 将毫秒转换为小时：1小时 = 3600000毫秒
							this.durationTotal += parseFloat(item.duration) / 3600000;
						}
					});
				}
				// 保留1位小数
				this.durationTotal = parseFloat(this.durationTotal.toFixed(1));
			}
		}
	};
</script>
